export const FileType = [
  { type: "Prezentacija", formats: ".ppt, .pptx" },
  { type: "Dokument", formats: ".doc, .docx, .pdf, .ppt, .pptx" },
  { type: "Tablica", formats: ".xls, .xlsx" },
  { type: "Slika", formats: ".jpg, .jpeg" },
];
